const currentEnv = process.env.HOST_ENV;

const appUrl = () => {
    if (typeof window !== "undefined" && window.location?.origin) {
        return window.location.origin;
    }

    const urls = {
        LOCAL: "http://localhost:3000",
        QA: "https://consumer-web-au.qac24svc.dev",
        STAGING: "https://stage-consumer-web-au.qac24svc.dev",
        LNOD: "https://stage-c2b-website.qac24svc.dev",
        PRODUCTION: "https://www.cars24.com.au"
    };
    return process.env.APP_URL || urls[currentEnv];
};

const sellCarApiUrl = () => {
    const urls = {
        LOCAL: "https://car-service-java.qac24svc.dev",
        QA: "https://car-service-java.qac24svc.dev",
        STAGING: "https://car-service-stage.cars24.team",
        LNOD: "https://sellerengine-qa8.ninja24.in",
        PRODUCTION: "https://car-service-java.c24.tech"
    };
    return urls[currentEnv];
};

const apiUrl = () => {
    const urls = {
        LOCAL: "https://c2c-web.qac24svc.dev",
        STAGING: "https://api-staging.qac24svc.dev",
        QA: "https://api-se-qa1.qac24svc.dev",
        LNOD: "https://sellerengine-qa8.ninja24.in",
        PRODUCTION: "https://api.cars24.com"
    };
    return urls[currentEnv];
};

const ssrApiUrl = () => {
    const urls = {
        LOCAL: "http://c2c-web.qac24svc.dev",
        STAGING: "https://api-staging.qac24svc.dev",
        QA: "http://api-se-qa1.qac24svc.dev",
        LNOD: "http://sellerengine-qa8.ninja24.in",
        PRODUCTION: "http://api.cars24.com"
    };
    return urls[currentEnv];
};

const vehicleApiUrl = () => {
    const urls = {
        LOCAL: "https://vehicle-service.qac24svc.dev",
        STAGING: "https://vehicle-service.qac24svc.dev",
        QA: "https://vehicle-service.qac24svc.dev",
        LNOD: "https://vehicle-service.qac24svc.dev",
        PRODUCTION: "https://vehicle.cars24.team"
    };
    return urls[currentEnv];
};

const b2cInventoryApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-inventory.qac24svc.dev",
        STAGING: "https://stage-b2c-inventory.qac24svc.dev",
        QA: "https://b2c-inventory.qac24svc.dev",
        LNOD: "https://b2c-inventory.qac24svc.dev",
        PRODUCTION: "https://b2c-inventory.c24.tech"
    };
    return urls[currentEnv];
};

const vehicleSSRApiUrl = () => {
    const urls = {
        LOCAL: "http://vehicle-service.qac24svc.dev",
        STAGING: "http://vehicle-service.qac24svc.dev",
        QA: "http://vehicle-service.qac24svc.dev",
        LNOD: "http://vehicle-service.qac24svc.dev",
        PRODUCTION: "https://vehicle.cars24.team"
    };
    return urls[currentEnv];
};

const staticAppUrl = () => {
    const urls = {
        LOCAL: "https://staging-static.cars24.com",
        QA: "https://static.cars24.com",
        STAGING: "https://static.cars24.com",
        LNOD: "https://staging-static.cars24.com",
        PRODUCTION: "https://static.cars24.com"
    };
    return urls[currentEnv];
};

const getPrivateProductApiKey = () => {
    const urls = {
        QA: "c2c-s4583HJKH58",
        STAGING: "pp-ui-s32578KJDHS",
        PRODUCTION: "qGuMZcWGxZpgd8uSH4rgkal4v1evAlCd"
    };
    return urls[currentEnv];
};

const ppApiUrl = () => {
    const urls = {
        LOCAL: "https://pvt-product.qac24svc.dev",
        QA: "https://pvt-product.qac24svc.dev",
        STAGING: "https://pvt-product-stage.cars24.com",
        LNOD: "https://pvt-product-stage.cars24.com",
        PRODUCTION: "https://pvt-product.cars24.com"
    };
    return urls[currentEnv];
};

const c2bKeys = {
    LOCAL: "YzJiX2Zyb250ZW5kOmJBVllHRVlzODZIWDVDd01jcmo5M01DQklvOEs2b2xo",
    QA: "YzJiX2Zyb250ZW5kOkszcHJyT0cwNm1uZE41V0FMS0NTQUxuQVd3eHBXQ0hJ",
    STAGING: "YzJiX2Zyb250ZW5kOmJBVllHRVlzODZIWDVDd01jcmo5M01DQklvOEs2b2xo",
    PRODUCTION: "YzJiX2Zyb250ZW5kOko1SXRmQTk2bTJfY3lRVk00dEtOSnBYaFJ0c0NtY1h1"
};

const c2bAuthKey = () => {
    return c2bKeys[currentEnv];
};

const sellCarAuthKey = () => {
    const keys = {
        LOCAL: "Y2FyX3NlcnZpY2VfdXNlcl9xYTpxYzBhZThmNGE3YTQzNmY1ZmQyODJxYTFlM2JlNTZjODFiOTM3OQ==",
        QA: "Y2FyX3NlcnZpY2VfdXNlcl9xYTpxYzBhZThmNGE3YTQzNmY1ZmQyODJxYTFlM2JlNTZjODFiOTM3OQ==",
        STAGING: "YWRtaW46cGFzc3dvcmQ=",
        PRODUCTION: "Y2FyX3NlcnZpY2VfdXNlcjpwZDBhZThmNGE3YTQzNmY1ZmQyOHByb2QyMWUzYmU1NmNiOTM3OQ=="
    };
    return keys[currentEnv];
};

const lmsAuthKey = () => {
    const keys = {
        LOCAL: "8a223df3-9fbd-426e-aa2f-e79bdcf60f61",
        QA: "8a223df3-9fbd-426e-aa2f-e79bdcf60f61",
        STAGING: "01e72f78-24f1-434a-ab6b-3342d75c352e",
        PRODUCTION: "b78f06db-d0d7-4c60-b1a6-fc153d2527be"
    };
    return keys[currentEnv];
};

const getLogoURL = () => {
    return `https://static-cdn.cars24.com/qa/cms/2026/02/06/1bc6ab79-d0f5-48bc-8f96-8429c73b26e6cars24-blue.svg`;
};

const getTransparentLogoURL = () => {
    return `https://static-cdn.cars24.com/qa/cms/2026/02/10/268c7020-6184-4b0a-86f5-cf099f1b3998blue-transparent.svg`;
};

const getLogoURLWhite = () => {
    return `https://static-cdn.cars24.com/qa/cms/2026/01/06/44fa3590-49e9-43da-a826-6466d185bfa2cars24-logo.svg`;
};

const getBlueLogoUrl = () => {
    return `https://static-cdn.cars24.com/qa/cms/2026/02/06/1bc6ab79-d0f5-48bc-8f96-8429c73b26e6cars24-blue.svg`;
};

const exchangeApiUrl = () => {
    const urls = {
        LOCAL: "https://c2b-website.qac24svc.dev",
        QA: "https://exchange-service-qa.ninja24.in",
        STAGING: "https://exchange-service-stage.cars24.team",
        LNOD: "https://exchange-service-qa.ninja24.in",
        PRODUCTION: "https://exchange-service.cars24.team"
    };
    return urls[currentEnv];
};

const checkoutApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-oms-au.qac24svc.dev",
        QA: "https://b2c-oms-au.qac24svc.dev",
        STAGING: "https://stage-b2c-oms-au.qac24svc.dev",
        LNOD: "https://b2c-oms-au.qac24svc.dev",
        PRODUCTION: "https://b2c-oms-au.c24.tech"
    };
    return urls[currentEnv];
};

const slotsApiUrl = () => {
    const urls = {
        LOCAL: "https://slot-planner-au.qac24svc.dev",
        QA: "https://slot-planner-au.qac24svc.dev",
        STAGING: "https://stage-slot-planner-au.qac24svc.dev",
        LNOD: "https://slot-planner-au.qac24svc.dev",
        PRODUCTION: "https://slot-planner-au.c24.tech"
    };
    return urls[currentEnv];
};

const paymentApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-payment-service-au.qac24svc.dev",
        QA: "https://b2c-payment-service-au.qac24svc.dev",
        STAGING: "https://stage-b2c-payment-service-au.qac24svc.dev",
        LNOD: "https://b2c-payment-service-au.qac24svc.dev",
        PRODUCTION: "https://b2c-payment-service-au.c24.tech"
    };
    return urls[currentEnv];
};

const b2cDrivaApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-driva-driver.qac24svc.dev",
        QA: "https://b2c-driva-driver.qac24svc.dev",
        STAGING: "https://stage-b2c-driva-driver.qac24svc.dev",
        LNOD: "https://b2c-oms.qac24svc.dev",
        PRODUCTION: "https://b2c-driva-driver.c24.tech"
    };
    return urls[currentEnv];
};

const greenIDApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-dms-au.qac24svc.dev",
        QA: "https://b2c-dms-au.qac24svc.dev",
        STAGING: "https://stage-b2c-dms-au.qac24svc.dev",
        LNOD: "https://b2c-dms-au.qac24svc.dev",
        PRODUCTION: "https://b2c-dms-au.c24.tech"
    };
    return urls[currentEnv];
};

const tradeInApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-tradein-service.qac24svc.dev",
        QA: "https://b2c-tradein-service.qac24svc.dev",
        STAGING: "https://stage-b2c-tradein-service.qac24svc.dev",
        LNOD: "https://b2c-tradein-service.qac24svc.dev",
        PRODUCTION: "https://b2c-tradein-service.c24.tech"
    };
    return urls[currentEnv];
};

const consumerFinanceApiUrl = () => {
    const urls = {
        LOCAL: "https://consumer-finance-stage.cars24.team",
        QA: "https://stage-consumer-finance-engine.qac24svc.dev/",
        STAGING: "https://stage-consumer-finance-engine.qac24svc.dev/",
        LNOD: "https://consumer-finance-stage.cars24.team/",
        PRODUCTION: "https://simpler-engine.cars24.team/"
    };
    return urls[currentEnv];
};

const bffBaseUrl = () => {
    const urls = {
        LOCAL: "https://gcp-bff-stage.qac24svc.dev",
        QA: "https://gcp-bff-stage.qac24svc.dev",
        STAGING: "https://gcp-bff-stage.qac24svc.dev",
        LNOD: "https://gcp-bff-stage.qac24svc.dev",
        PRODUCTION: "https://bff-au.c24.tech"
    };
    return urls[currentEnv];
};

const listingApiUrl = () => {
    const urls = {
        LOCAL: "https://listing-service-au.qac24svc.dev",
        QA: "https://listing-service-au.qac24svc.dev",
        STAGING: "https://stage-listing-service-au.qac24svc.dev",
        LNOD: "https://listing-service-au.qac24svc.dev",
        PRODUCTION: "https://listing-service-au.c24.tech"
    };
    return urls[currentEnv];
};
const listingSSRApiUrl = () => {
    const urls = {
        LOCAL: "https://listing-service-au.qac24svc.dev",
        QA: "http://listing-service-au",
        STAGING: "https://stage-listing-service-au.qac24svc.dev",
        LNOD: "http://listing-service-au",
        PRODUCTION: "http://listing-service-au"
        // PRODUCTION: "http://listing-service-au"
    };
    return urls[currentEnv];
};
const leadApiUrl = () => {
    const urls = {
        LOCAL: "https://lead-collector-stage.cars24.team",
        QA: "https://stage-lead-collector-service.qac24svc.dev",
        STAGING: "https://stage-lead-collector-service.qac24svc.dev",
        LNOD: "https://lead-collector-stage.cars24.team",
        PRODUCTION: "https://lead-collector.cars24.team"
    };
    return urls[currentEnv];
};

const b2cMasterDataSSRApi = () => {
    const urls = {
        LOCAL: "http://b2c-masterdata.qac24svc.dev",
        STAGING: "http://stage-b2c-masterdata.qac24svc.dev",
        QA: "http://b2c-masterdata.qac24svc.dev",
        LNOD: "http://b2c-masterdata.qac24svc.dev",
        PRODUCTION: "http://b2c-masterdata"
    };
    return urls[currentEnv];
};

const b2cMasterDataApi = () => {
    const urls = {
        LOCAL: "https://b2c-masterdata.qac24svc.dev",
        STAGING: "https://stage-b2c-masterdata.qac24svc.dev",
        QA: "https://b2c-masterdata.qac24svc.dev",
        LNOD: "https://b2c-masterdata.qac24svc.dev",
        PRODUCTION: "https://b2c-masterdata.c24.tech"
    };
    return urls[currentEnv];
};

const leadApiUrlKey = () => {
    const keys = {
        LOCAL: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        QA: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        STAGING: "6f355999-4af7-4c3a-8816-a16aaf2d8994",
        PRODUCTION: "6f355999-4af7-4c3a-8816-a16aaf2d8994"
    };
    return keys[currentEnv];
};

const cloudFunctionsURL = () => {
    const urls = {
        LOCAL: "https://asia-south1-production-283804.cloudfunctions.net",
        QA: "https://asia-south1-production-283804.cloudfunctions.net",
        STAGING: "https://asia-south1-production-283804.cloudfunctions.net",
        PRODUCTION: "https://asia-south1-production-283804.cloudfunctions.net"
    };
    return urls[currentEnv];
};

const cmsURl = () => {
    const urls = {
        LOCAL: "https://www.cars24.com.au",
        QA: "https://www.cars24.com.au",
        STAGING: "https://stage-consumer-web-au.qac24svc.dev",
        LNOD: "https://www.cars24.com.au",
        PRODUCTION: "https://www.cars24.com.au"
    };
    return urls[currentEnv];
};

const b2cConsumerFinance = () => {
    const urls = {
        LOCAL: "https://b2c-consumer-finance-au.qac24svc.dev",
        QA: "https://b2c-consumer-finance-au.qac24svc.dev",
        STAGING: "https://stage-b2c-consumer-finance-au.qac24svc.dev",
        LNOD: "https://b2c-consumer-finance-au.qac24svc.dev",
        PRODUCTION: "https://b2c-consumer-finance-au.c24.tech"
    };
    return urls[currentEnv];
};

const nudgeApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-alert-service.qac24svc.dev",
        QA: "https://b2c-alert-service.qac24svc.dev",
        STAGING: "https://stage-b2c-alert-service.qac24svc.dev",
        LNOD: "https://b2c-alert-service.qac24svc.dev",
        PRODUCTION: "https://b2c-alert-service.c24.tech"
    };
    return urls[currentEnv];
};

const signContractApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-doc-sign-service-au.qac24svc.dev",
        QA: "https://b2c-doc-sign-service-au.qac24svc.dev",
        STAGING: "https://stage-b2c-doc-sign-service-au.qac24svc.dev",
        LNOD: "https://b2c-doc-sign-service-au.qac24svc.dev",
        PRODUCTION: "https://b2c-doc-sign-service-au.c24.tech"
    };
    return urls[currentEnv];
};

const c2bTradeApiUrl = () => {
    const urls = {
        LOCAL: "https://c2b-trade-service-au.qac24svc.dev",
        QA: "https://c2b-trade-service-au.qac24svc.dev",
        STAGING: "https://stage-c2b-trade-service-au.qac24svc.dev",
        LNOD: "https://c2b-trade-service-au.qac24svc.dev",
        PRODUCTION: "https://c2b-trade-service-au.c24.tech"
    };
    return urls[currentEnv];
};

const c2bTradeSSRApiUrl = () => {
    const urls = {
        LOCAL: "https://c2b-trade-service-au.qac24svc.dev",
        QA: "http://c2b-trade-service-au",
        STAGING: "https://stage-c2b-trade-service-au.qac24svc.dev",
        LNOD: "http://c2b-trade-service-au",
        // PRODUCTION: "https://c2b-trade-service-au.c24.tech",
        PRODUCTION: "http://c2b-trade-service-au"
    };
    return urls[currentEnv];
};

const configApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-app-config-au.qac24svc.dev",
        QA: "https://b2c-app-config-au.qac24svc.dev",
        STAGING: "https://stage-b2c-app-config-au.qac24svc.dev",
        LNOD: "https://b2c-app-config-au.qac24svc.dev",
        PRODUCTION: "https://b2c-app-config-au.c24.tech"
    };
    return urls[currentEnv];
};

const configSSRApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-app-config-au.qac24svc.dev",
        QA: "http://b2c-app-config-au",
        STAGING: "https://b2c-app-config-au.qac24svc.dev",
        LNOD: "http://b2c-app-config-au",
        // PRODUCTION: "https://b2c-app-config-au.c24.tech",
        PRODUCTION: "http://b2c-app-config-au"
    };
    return urls[currentEnv];
};

const b2cHubspotApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-hubspot-service-au.qac24svc.dev",
        QA: "https://b2c-hubspot-service-au.qac24svc.dev",
        STAGING: "https://stage-b2c-hubspot-service-au.qac24svc.dev",
        LNOD: "https://b2c-hubspot-service-au.qac24svc.dev",
        PRODUCTION: "https://b2c-hubspot-service-au.c24.tech/"
    };
    return urls[currentEnv];
};

const bffApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-app-config-au.qac24svc.dev",
        QA: "https://b2c-bff-au.qac24svc.dev",
        STAGING: "https://stage-b2c-bff-au.qac24svc.dev",
        LNOD: "https://b2c-app-config-au.qac24svc.dev",
        PRODUCTION: "https://b2c-bff-au.c24.tech"
    };
    return urls[currentEnv];
};

const centralPaymentBffUrl = () => {
    const urls = {
        STAGING: "https://c24-bff-service-stage.qac24svc.dev",
        PRODUCTION: "https://api.cars24.com/gw/plt/bffsvcplt"
    };
    return process.env.STRIPE_CENTRAL_PAYMENT_BFF_URL || urls[currentEnv];
};

const stripeSessionBffUrl = () => {
    const urls = {
        STAGING: "https://c24-bff-service-stage.qac24svc.dev",
        PRODUCTION: "https://api.cars24.com/gw/plt/bffsvcplt"
    };
    return process.env.STRIPE_SESSION_BFF_URL || urls[currentEnv];
};

const bffSSRApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-app-config-au.qac24svc.dev",
        QA: "http://b2c-bff-au",
        // STAGING: "http://b2c-bff-au",
        STAGING: "https://stage-b2c-bff-au.qac24svc.dev",
        LNOD: "http://b2c-app-config-au",
        // PRODUCTION: "https://b2c-bff-au.c24.tech",
        PRODUCTION: "http://b2c-bff-au"
    };
    return urls[currentEnv];
};

// Catalog aggregator (execution_graph) BFF — hosts /api/v1/sitemap (combined AU sitemap merge).
// Distinct from bffSSRApiUrl above, which points at the b2c-bff-au service.
// SUPER_APP_BFF_URL override lets local dev point at whichever BFF has the spec deployed
// (e.g. the prod host) without touching the per-env mapping.
const superAppBffSSRUrl = () => {
    const urls = {
        LOCAL: "https://gcp-bff-stage.qac24svc.dev",
        QA: "https://gcp-bff-stage.qac24svc.dev",
        STAGING: "https://gcp-bff-stage.qac24svc.dev",
        LNOD: "https://gcp-bff-stage.qac24svc.dev",
        PRODUCTION: "https://bff-au.c24.tech"
    };
    return process.env.SUPER_APP_BFF_URL || urls[currentEnv];
};

const inHouseApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-inhouse-finance-au.qac24svc.dev",
        QA: "https://b2c-inhouse-finance-au.qac24svc.dev",
        STAGING: "https://stage-b2c-inhouse-finance-au.qac24svc.dev",
        LNOD: "https://b2c-inhouse-finance-au.qac24svc.dev",
        PRODUCTION: "https://b2c-inhouse-finance-au.c24.tech"
    };
    return urls[currentEnv];
};

const b2cBffApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-bff-au.qac24svc.dev",
        QA: "https://b2c-bff-au.qac24svc.dev",
        STAGING: "https://stage-b2c-bff-au.qac24svc.dev",
        LNOD: "https://b2c-app-config-au.qac24svc.dev",
        PRODUCTION: "https://b2c-bff-au.c24.tech"
    };
    return urls[currentEnv];
};

const carSalesListingUrl = () => {
    const urls = {
        LOCAL: "https://www.carsales.com.au/cars",
        QA: "https://www.carsales.com.au/cars",
        STAGING: "https://www.carsales.com.au/cars",
        LNOD: "https://www.carsales.com.au/cars",
        PRODUCTION: "https://www.carsales.com.au/cars"
    };
    return urls[currentEnv];
};

const b2cInHouseFinanceApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-bff-au.qac24svc.dev",
        QA: "https://b2c-bff-au.qac24svc.dev",
        STAGING: "https://stage-b2c-bff-au.qac24svc.dev",
        LNOD: "https://b2c-oms.qac24svc.dev",
        PRODUCTION: "https://b2c-bff-au.c24.tech"
    };
    return urls[currentEnv];
};

const vasApiUrl = () => {
    const urls = {
        LOCAL: "https://vas-service-au.qac24svc.dev",
        QA: "https://vas-service-au.qac24svc.dev",
        STAGING: "https://stage-vas-service-au.qac24svc.dev",
        LNOD: "https://vas-service-au.qac24svc.dev",
        PRODUCTION: "https://vas-service-au.c24.tech"
    };
    return urls[currentEnv];
};

const b2cFinanceApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-finance-au.qac24svc.dev",
        QA: "https://b2c-finance-au.qac24svc.dev",
        STAGING: "https://stage-b2c-finance-au.qac24svc.dev",
        LNOD: "https://b2c-finance-au.qac24svc.dev",
        PRODUCTION: "https://b2c-finance-au.c24.tech"
    };
    return urls[currentEnv];
};

const b2cFinanceSSRApiUrl = () => {
    const urls = {
        LOCAL: "https://b2c-finance-au.qac24svc.dev",
        QA: "http://b2c-finance-au",
        STAGING: "http://b2c-finance-au",
        LNOD: "http://b2c-finance-au",
        // PRODUCTION: "https://b2c-finance-au.c24.tech",
        PRODUCTION: "http://b2c-finance-au"
    };
    return urls[currentEnv];
};

const geoLocationApiUrl = () => {
    const urls = {
        LOCAL: "https://user-authentication-service-au.qac24svc.dev",
        QA: "https://user-authentication-service-au.qac24svc.dev",
        STAGING: "https://stage-user-authentication-service-au.qac24svc.dev",
        LNOD: "https://user-authentication-service-au.qac24svc.dev",
        PRODUCTION: "http://user-authentication-service-au"
    };
    return urls[currentEnv];
};

const addParamsToURL = (urlString, paramsString) => {
    const url = urlString.includes("?") ? `${urlString}&${paramsString}` : `${urlString}?${paramsString}`;
    return url;
};

module.exports = {
    currentEnv,
    appUrl,
    apiUrl,
    ssrApiUrl,
    staticAppUrl,
    getPrivateProductApiKey,
    ppApiUrl,
    c2bAuthKey,
    getLogoURL,
    exchangeApiUrl,
    sellCarApiUrl,
    sellCarAuthKey,
    lmsAuthKey,
    vehicleApiUrl,
    vehicleSSRApiUrl,
    checkoutApiUrl,
    b2cDrivaApiUrl,
    b2cInHouseFinanceApiUrl,
    tradeInApiUrl,
    consumerFinanceApiUrl,
    bffBaseUrl,
    listingApiUrl,
    b2cMasterDataSSRApi,
    b2cInventoryApiUrl,
    leadApiUrl,
    leadApiUrlKey,
    b2cMasterDataApi,
    c2bKeys,
    cloudFunctionsURL,
    cmsURl,
    b2cConsumerFinance,
    nudgeApiUrl,
    signContractApiUrl,
    c2bTradeApiUrl,
    configApiUrl,
    paymentApiUrl,
    b2cHubspotApiUrl,
    bffApiUrl,
    centralPaymentBffUrl,
    stripeSessionBffUrl,
    b2cBffApiUrl,
    carSalesListingUrl,
    greenIDApiUrl,
    inHouseApiUrl,
    b2cFinanceApiUrl,
    vasApiUrl,
    slotsApiUrl,
    geoLocationApiUrl,
    listingSSRApiUrl,
    configSSRApiUrl,
    bffSSRApiUrl,
    superAppBffSSRUrl,
    b2cFinanceSSRApiUrl,
    c2bTradeSSRApiUrl,
    addParamsToURL,
    getLogoURLWhite,
    getBlueLogoUrl,
    getTransparentLogoURL
};
